import {
  ChangeDetectionStrategy,
  Component,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import {
  FieldWrapper,
  FormlyFieldConfig,
  FormlyFieldProps,
} from '@ngx-formly/core';
import { includes } from 'lodash';

interface AddonsWrapperComponentProps extends FormlyFieldProps {
  tooltip: {
    text: string;
    position: string;
    xPosition?: string;
    yPosition?: string;
  };
  addonRight: string;
  addonLeft: string;
  prefix: TemplateRef<any>;
  suffix: TemplateRef<any>;
}

@Component({
    selector: 'lockton-apps-addons-wrapper',
    templateUrl: './addons-wrapper.component.html',
    styleUrls: ['./addons-wrapper.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class AddonsWrapperComponent extends FieldWrapper<
  FormlyFieldConfig<AddonsWrapperComponentProps>
> {
  @ViewChild('matPrefix', { static: true }) matPrefix!: TemplateRef<any>;
  @ViewChild('matSuffix', { static: true }) matSuffix!: TemplateRef<any>;

  public ngAfterViewInit(): void {
    if (this.matPrefix && this.props.addonLeft) {
      this.props.prefix = this.matPrefix;
    }

    if (this.matSuffix && this.props.addonRight) {
      this.props.suffix = this.matSuffix;
    }
  }

  get isInline(): boolean {
    return includes(
      ['image-file-input', 'select-box', 'template'],
      this.field.type
    );
  }
}
